import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5249365a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "company-id" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_6 = { class: "mt-6" }
const _hoisted_7 = {
  key: 0,
  class: "flex items-center justify-center flex-col bg-white border px-6 py-4"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 text-sm mt-2" }, "Загрузка данных о компании...", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-red-400 text-sm" }, " При получении данных о компании произошла ошибка ", -1))
const _hoisted_10 = {
  key: 1,
  class: "grid grid-cols-3 gap-3 bg-white border px-6 py-4"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold" }, "Сокращенное название", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold" }, "БИН", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold" }, "БИК", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold" }, "КБЕ", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold" }, "Счёт", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold" }, "Контактный email", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold" }, "Контактное имя", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold" }, "Контактный телефон", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold" }, "Номер договора", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold" }, "Фактический адрес", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold" }, "Юридический адрес", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold" }, "Номер НДС", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold" }, "Серия НДС", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold" }, "Дата создания", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold" }, "Ответственный бухгалтер", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold" }, "Период", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold" }, "Инициатор", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold" }, "Услуги", -1))
const _hoisted_29 = {
  key: 0,
  class: "flex items-center justify-center flex-col bg-white border px-6 py-4 mt-6"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 text-sm mt-2" }, " Загрузка данных о графике работы компании... ", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-red-400 text-sm" }, " При получении данных о графике работы компании произошла ошибка ", -1))
const _hoisted_32 = {
  key: 2,
  class: "text-gray-400 text-sm"
}
const _hoisted_33 = {
  key: 1,
  class: "bg-white border px-6 py-4 mt-6 grid grid-cols-2 gap-6"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold mb-3" }, "График работы отправителя", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold mb-3" }, "График работы получателя", -1))
const _hoisted_36 = {
  key: 3,
  class: "mt-6"
}
const _hoisted_37 = {
  key: 0,
  class: "bg-white border px-6 py-4 flex flex-col justify-center items-center gap-3"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-red-500" }, "При получении договоров произошла ошибка", -1))
const _hoisted_39 = {
  key: 2,
  class: "text-sm"
}
const _hoisted_40 = {
  key: 0,
  style: {"width":"300px","white-space":"initial"}
}
const _hoisted_41 = { class: "flex items-center" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1))
const _hoisted_44 = {
  key: 0,
  class: "flex items-center justify-center flex-col bg-white border px-6 py-4 mt-6"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 text-sm mt-2" }, " Загрузка истории изменений компании... ", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-red-400 text-sm" }, " При получении истории изменений компании произошла ошибка ", -1))
const _hoisted_47 = {
  key: 2,
  class: "text-gray-400 text-sm"
}
const _hoisted_48 = {
  key: 1,
  class: "CompanyChatHolder"
}
const _hoisted_49 = { class: "CompanyChat" }
const _hoisted_50 = { class: "ItemTitle" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ItemCheck" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check" })
], -1))
const _hoisted_52 = { key: 0 }
const _hoisted_53 = ["href"]
const _hoisted_54 = {
  key: 1,
  class: "flex items-center justify-center mt-3 bg-white rounded py-3 px-4"
}
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 text-sm" }, "Загрузка списка...", -1))
const _hoisted_56 = { key: 2 }
const _hoisted_57 = {
  key: 0,
  class: "fas mr-2 fa-toggle-on"
}
const _hoisted_58 = {
  key: 1,
  class: "fas mr-2 fa-toggle-off"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_companies_tabs = _resolveComponent("companies-tabs")!
  const _component_loader = _resolveComponent("loader")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_the_table = _resolveComponent("the-table")!
  const _component_table_scroll_wrapper = _resolveComponent("table-scroll-wrapper")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_page_title, { title: _ctx.getCompanyTitle }, null, 8, ["title"]),
        (Boolean(_ctx.state.company))
          ? (_openBlock(), _createBlock(_component_cheap, {
              key: 0,
              class: _normalizeClass(["small ml-3", { green: _ctx.state.company.billing_enabled }])
            }, {
              default: _withCtx(() => [
                (_ctx.state.company.billing_enabled)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode("Биллинг включен")
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode("Биллинг выключен")
                    ], 64))
              ]),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true),
        (_ctx.state.company && _ctx.state.company.status_id)
          ? (_openBlock(), _createBlock(_component_cheap, {
              key: 1,
              class: _normalizeClass(_ctx.getStatusClass(_ctx.state.company.status_id))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.state.company.status), 1)
              ]),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true),
        (_ctx.isCompanyTimeSlotsEnabled)
          ? (_openBlock(), _createBlock(_component_cheap, {
              key: 2,
              class: "ml-3 small green"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Тайм-слоты доступны ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_the_button, {
          class: "second small text",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/companies')))
        }, {
          default: _withCtx(() => [
            _hoisted_5,
            _createTextVNode(" Назад ")
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_companies_tabs, {
      class: "mt-6",
      value: _ctx.state.currentTab,
      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.currentTab) = $event))
    }, null, 8, ["value"]),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.state.is_loading || _ctx.state.is_failed)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (_ctx.state.is_loading)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_loader, { class: "primary" }),
                  _hoisted_8
                ], 64))
              : (_ctx.state.is_failed)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_9,
                    _createVNode(_component_the_button, {
                      class: "primary small text mt-3",
                      onClick: _ctx.loadCompany
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Перезагрузить ")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ], 64))
                : _createCommentVNode("", true)
          ]))
        : (_ctx.state.company && _ctx.isGeneral)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", null, [
                _hoisted_11,
                _createElementVNode("p", null, _toDisplayString(_ctx.state.company.short_name || '-'), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_12,
                _createElementVNode("p", null, _toDisplayString(_ctx.state.company.bin || '-'), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_13,
                _createElementVNode("p", null, _toDisplayString(_ctx.state.company.bik || '-'), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_14,
                _createElementVNode("p", null, _toDisplayString(_ctx.state.company.kbe || '-'), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_15,
                _createElementVNode("p", null, _toDisplayString(_ctx.state.company.bank_account || '-'), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_16,
                _createElementVNode("p", null, _toDisplayString(_ctx.state.company.contact_email || '-'), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_17,
                _createElementVNode("p", null, _toDisplayString(_ctx.state.company.contact_name || '-'), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_18,
                _createElementVNode("p", null, _toDisplayString(_ctx.state.company.contact_phone || '-'), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_19,
                _createElementVNode("p", null, _toDisplayString(_ctx.state.company.contract_number || '-'), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_20,
                _createElementVNode("p", null, _toDisplayString(_ctx.state.company.fact_address || '-'), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_21,
                _createElementVNode("p", null, _toDisplayString(_ctx.state.company.jur_address || '-'), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_22,
                _createElementVNode("p", null, _toDisplayString(_ctx.state.company.nds_number || '-'), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_23,
                _createElementVNode("p", null, _toDisplayString(_ctx.state.company.nds_series || '-'), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_24,
                _createElementVNode("p", null, _toDisplayString(_ctx.formatDateWithTimeFromBackend(_ctx.state.company.created_at) || '-'), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_25,
                _createElementVNode("p", null, [
                  (_ctx.isHaveAccountant)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.state.company.accountant.name) + " (" + _toDisplayString(_ctx.state.company.accountant.email) + ")", 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode("-")
                      ], 64))
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_26,
                _createElementVNode("p", null, _toDisplayString(_ctx.state.company.billing_period
                                    ? _ctx.state.company.billing_period.title
                                    : '-'), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_27,
                _createElementVNode("p", null, _toDisplayString(_ctx.state.company.initiator_email || '-'), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_28,
                _createElementVNode("p", null, [
                  (_ctx.state.company.contractServices && _ctx.state.company.contractServices.length > 0)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.state.company.contractServices.join(', ')), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(" - ")
                      ], 64))
                ])
              ])
            ]))
          : _createCommentVNode("", true),
      (_ctx.isGeneral)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            (
                        _ctx.schedules_state.is_loading ||
                        _ctx.schedules_state.is_failed ||
                        _ctx.schedules_state.schedules.length === 0
                    )
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  (_ctx.schedules_state.is_loading)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_loader, { class: "primary" }),
                        _hoisted_30
                      ], 64))
                    : (_ctx.schedules_state.is_failed)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _hoisted_31,
                          _createVNode(_component_the_button, {
                            class: "primary small text mt-3",
                            onClick: _ctx.loadCompanySchedule
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Перезагрузить ")
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ], 64))
                      : (_ctx.schedules_state.schedules.length === 0)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_32, " Нет данных о графике работы компании "))
                        : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_33, [
                  _createElementVNode("div", null, [
                    _hoisted_34,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.senderSchedules, (schedule) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: schedule.id,
                        class: "grid grid-cols-3 gap-3 py-2 border-b"
                      }, [
                        _createElementVNode("div", null, _toDisplayString(_ctx.WORK_WEEK_DAYS[schedule.weekday]), 1),
                        _createElementVNode("div", null, _toDisplayString(schedule.workTimeFrom), 1),
                        _createElementVNode("div", null, _toDisplayString(schedule.workTimeUntil), 1)
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_35,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.receiverSchedules, (schedule) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: schedule.id,
                        class: "grid grid-cols-3 gap-3 py-2 border-b"
                      }, [
                        _createElementVNode("div", null, _toDisplayString(_ctx.WORK_WEEK_DAYS[schedule.weekday]), 1),
                        _createElementVNode("div", null, _toDisplayString(schedule.workTimeFrom), 1),
                        _createElementVNode("div", null, _toDisplayString(schedule.workTimeUntil), 1)
                      ]))
                    }), 128))
                  ])
                ]))
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.isGeneral)
        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
            (_ctx.contracts_state.is_loading || _ctx.contracts_state.is_failed || _ctx.contracts_state.contracts.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                  (_ctx.contracts_state.is_loading)
                    ? (_openBlock(), _createBlock(_component_loader, {
                        key: 0,
                        class: "primary"
                      }))
                    : (_ctx.contracts_state.is_failed)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _hoisted_38,
                          _createVNode(_component_the_button, {
                            class: "primary small",
                            onClick: _ctx.loadContracts
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Попробовать еще раз")
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ], 64))
                      : (_ctx.contracts_state.contracts.length === 0)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_39, "Список договоров пуст"))
                        : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createBlock(_component_table_scroll_wrapper, {
                  key: 1,
                  loading: _ctx.contracts_state.is_loading
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_the_table, {
                      loading: _ctx.contracts_state.is_loading,
                      columns: _ctx.ContractsColumns,
                      rows: _ctx.contracts_state.contracts
                    }, {
                      td: _withCtx(({ column, row }) => [
                        (column.key === 'number')
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              class: "text-blue-500",
                              to: `/contracts/${row.id}`
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(row.number), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          : (column.key === 'date')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(_ctx.formatDateFromBackend(row.date)), 1)
                              ], 64))
                            : (column.key === 'expiration_date')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                  _createTextVNode(_toDisplayString(_ctx.formatDateFromBackend(row.expiration_date)), 1)
                                ], 64))
                              : (column.key === 'services')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                    (row.services && row.services.length > 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(row.services.map((service) => service.name).join(', ')), 1))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _createTextVNode(" - ")
                                        ], 64))
                                  ], 64))
                                : (column.key === 'status' && row.status && row.status_id)
                                  ? (_openBlock(), _createBlock(_component_cheap, {
                                      key: 4,
                                      class: _normalizeClass(`small ${_ctx.ContractsStatusColors[row.status_id]}`)
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(row.status), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["class"]))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                      _createTextVNode(_toDisplayString(row[column.key] || '-'), 1)
                                    ], 64))
                      ]),
                      _: 1
                    }, 8, ["loading", "columns", "rows"])
                  ]),
                  _: 1
                }, 8, ["loading"]))
          ]))
        : _createCommentVNode("", true),
      (_ctx.isChat)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
            _createElementVNode("form", {
              class: "CompanyChatFilters",
              onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.loadCompanyActivity && _ctx.loadCompanyActivity(...args)), ["prevent"]))
            }, [
              _createVNode(_component_the_input, {
                type: "date",
                placeholder: "Дата от",
                value: _ctx.state.createdAtFrom,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.createdAtFrom) = $event))
              }, null, 8, ["value"]),
              _createVNode(_component_the_input, {
                type: "date",
                placeholder: "Дата от",
                value: _ctx.state.createdAtTo,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.createdAtTo) = $event))
              }, null, 8, ["value"]),
              _createElementVNode("div", _hoisted_41, [
                _createVNode(_component_the_button, {
                  class: "second text small mr-2",
                  disabled: _ctx.activity_state.is_loading,
                  onClick: _ctx.reset
                }, {
                  default: _withCtx(() => [
                    _hoisted_42,
                    _createTextVNode(" Сбросить ")
                  ]),
                  _: 1
                }, 8, ["disabled", "onClick"]),
                _createVNode(_component_the_button, {
                  class: "primary text small",
                  loading: _ctx.activity_state.is_loading,
                  type: "submit"
                }, {
                  default: _withCtx(() => [
                    _hoisted_43,
                    _createTextVNode(" Поиск ")
                  ]),
                  _: 1
                }, 8, ["loading"])
              ])
            ], 32),
            (
                        _ctx.activity_state.is_loading ||
                        _ctx.activity_state.is_failed ||
                        _ctx.activity_state.activities.length === 0
                    )
              ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                  (_ctx.activity_state.is_loading)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_loader, { class: "primary" }),
                        _hoisted_45
                      ], 64))
                    : (_ctx.activity_state.is_failed)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _hoisted_46,
                          _createVNode(_component_the_button, {
                            class: "primary small text mt-3",
                            onClick: _ctx.loadCompanyActivity
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Перезагрузить ")
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ], 64))
                      : (_ctx.activity_state.activities.length === 0)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_47, "История изменений компании пуста"))
                        : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activity_state.activities, (item, idx) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: `chat-item-${idx}`,
                        class: "CompanyChat__item"
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.actions, (action, k) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: `action-${k}`,
                            class: "w-full"
                          }, [
                            _createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.formatDateFromBackend(item.date)) + " " + _toDisplayString(action.action.name) + ": " + _toDisplayString(action.count) + " " + _toDisplayString(_ctx.getCountText(action.count)), 1),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(action.activities, (card, i) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "ItemContent",
                                key: `card-${i}`
                              }, [
                                _hoisted_51,
                                _createElementVNode("div", null, [
                                  _createElementVNode("span", null, _toDisplayString(card.message), 1),
                                  (card.url)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_52, [
                                        _createTextVNode(" Ссылка на объект: "),
                                        _createElementVNode("a", {
                                          href: card.url,
                                          target: "_blank",
                                          class: "font-semibold text-blue-500 underline"
                                        }, _toDisplayString(card.url), 9, _hoisted_53)
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            }), 128))
                          ]))
                        }), 128))
                      ]))
                    }), 128))
                  ])
                ]))
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.isSettings)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
            (
                        _ctx.settings_state.settings.is_failed &&
                        !_ctx.settings_state.settings.failure.error_state.is_cancel
                    )
              ? (_openBlock(), _createBlock(_component_failed_fetch, {
                  key: 0,
                  loading: _ctx.settings_state.settings.is_loading,
                  text: "При получении списка графиков произошла ошибка",
                  "error-message": _ctx.settings_state.settings.failure.error_state.message,
                  "error-url": _ctx.settings_state.settings.failure.error_state.url,
                  "error-status": _ctx.settings_state.settings.failure.error_state.status,
                  onRefresh: _cache[5] || (_cache[5] = ($event: any) => (_ctx.loadSettings(_ctx.settings_state.settings.pagination.current_page)))
                }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
              : (_ctx.settings_state.settings.is_loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                    _createVNode(_component_loader, { class: "primary mr-1" }),
                    _hoisted_55
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_56, [
                    _createVNode(_component_table_scroll_wrapper, {
                      loading: _ctx.settings_state.settings.is_loading
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_the_table, {
                          loading: _ctx.settings_state.settings.is_loading,
                          columns: _ctx.NotificationsColumns,
                          rows: _ctx.settings_state.settings.list,
                          "with-limit": "",
                          "pagination-limit": _ctx.settings_state.limit,
                          "pagination-total-items": _ctx.settings_state.settings.pagination.total_items,
                          "pagination-current-page": 
                                _ctx.settings_state.settings.pagination.current_page
                            ,
                          "pagination-total-pages": _ctx.settings_state.settings.pagination.total_pages,
                          onChangePage: _ctx.loadSettings,
                          onChangeLimit: _ctx.onLimitChange
                        }, {
                          td: _withCtx(({ column, row }) => [
                            (column.key === 'description')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(_toDisplayString(row.description), 1)
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString(row[column.key] || '-'), 1)
                                ], 64))
                          ]),
                          actions: _withCtx(({ row }) => [
                            (_ctx.isCanManageSettings)
                              ? (_openBlock(), _createBlock(_component_the_button, {
                                  key: 0,
                                  loading: _ctx.settings_state.is_manage_loading,
                                  disabled: _ctx.settings_state.is_manage_loading,
                                  class: "primary text small",
                                  onClick: ($event: any) => (_ctx.manageActiveBtn(row))
                                }, {
                                  default: _withCtx(() => [
                                    (row.isActive)
                                      ? (_openBlock(), _createElementBlock("i", _hoisted_57))
                                      : (_openBlock(), _createElementBlock("i", _hoisted_58)),
                                    _createTextVNode(" " + _toDisplayString(_ctx.getActiveBtnText(row)), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["loading", "disabled", "onClick"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["loading", "columns", "rows", "pagination-limit", "pagination-total-items", "pagination-current-page", "pagination-total-pages", "onChangePage", "onChangeLimit"])
                      ]),
                      _: 1
                    }, 8, ["loading"])
                  ]))
          ], 64))
        : _createCommentVNode("", true)
    ])
  ]))
}